<template>
  <div
    class="bg-white dark:bg-gray-800 sm:rounded-lg shadow dark:shadow-gray-900/50 px-2 py-3 sm:p-4 mb-2 sm:mb-6"
  >
    <div class="flex flex-col gap-3 sm:gap-4 md:flex-row">
      <!-- Search input -->
      <div class="flex-1 relative">
        <MagnifyingGlassIcon
          class="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 dark:text-gray-500"
        />
        <input
          :value="searchQuery"
          @input="$emit('update:searchQuery', $event.target.value)"
          type="text"
          placeholder="Zoek op organisatie, onderwerp of verantwoordelijke..."
          class="w-full pl-10 pr-10 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 dark:text-white dark:placeholder-gray-400"
        />
        <button
          v-if="searchQuery"
          @click="$emit('update:searchQuery', '')"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
        >
          <XCircleIcon class="h-5 w-5" />
        </button>
      </div>

      <!-- Show completed toggle -->
      <label class="flex items-center gap-2 cursor-pointer whitespace-nowrap">
        <input
          :checked="showCompleted"
          @change="$emit('update:showCompleted', $event.target.checked)"
          type="checkbox"
          class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700"
        />
        <span class="text-sm text-gray-700 dark:text-gray-300">Toon afgeronde projecten</span>
      </label>

      <!-- Actions slot -->
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup>
import { MagnifyingGlassIcon, XCircleIcon } from '@heroicons/vue/24/outline'

defineProps({
  searchQuery: {
    type: String,
    default: ''
  },
  showCompleted: {
    type: Boolean,
    default: true
  }
})

defineEmits(['update:searchQuery', 'update:showCompleted'])
</script>
